import { RefObject, useEffect, useRef, useState } from 'react';

/**
 * Returns a hook that determines whether to show an element based on the width of a container.
 *
 * @param width - The minimum width at which the element should be shown.
 * @returns An object containing the `show` boolean and a ref to the element.
 */
export const useShowBasedOnWidth = (
  width: number,
): { show: boolean; elementRef: RefObject<HTMLDivElement | null> } => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState<boolean>(true);

  const handleResize = () => {
    if (!elementRef.current) {
      return;
    }

    const shouldShow = elementRef.current.offsetWidth >= width;

    setShow(shouldShow);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return { show, elementRef: elementRef as RefObject<HTMLDivElement | null> };
};
